import { useState, useEffect } from 'react';
import { useNetwork, useWalletClient } from 'wagmi';
import { getSupportedChain } from '../helpers/getSupportedChain';
import { getLendignOfferWithBalance } from '../helpers/checkBalance';

export const useGetLendignOffersWithBalance = ({
  offers,
  chainId,
  contract,
  sortByPrice = false,
}) => {
  const { data: walletClient } = useWalletClient();
  const { chain: defaultChain } = useNetwork();
  const [bids, setBids] = useState(
    offers ? offers?.map((offer) => ({ ...offer, isReady: false })) : [],
  );
  const currentChain = getSupportedChain(chainId) || defaultChain;

  useEffect(() => {
    if (offers) {
      try {
        let bidsWithBalance = offers;

        if (!contract || !bidsWithBalance.length) return setBids(bidsWithBalance);

        getLendignOfferWithBalance({
          contract,
          offers: bidsWithBalance,
          chain: currentChain,
          sortByPrice,
        }).then((bidsWithBalance) => {
          setBids(bidsWithBalance);
        });
      } catch (e) {
        console.log(e);
      }
    }
  }, [offers, currentChain, walletClient]);

  return bids;
};
